module.exports = __webpack_public_path__ + "static/media/left-arrow.2d978d2f.svg";